module.exports = __webpack_public_path__ + "static/media/mitten.346da7bd.svg";